<template>
    <div class="space-y-8">
        <!-- 后台任务管理 -->
        <div class="card bg-base-100 border border-base-200 shadow-sm transition-shadow duration-200 hover:shadow-md">
            <div class="card-body space-y-6">
                <div class="flex items-start gap-3">
                    <div class="mt-1 h-5 w-1.5 rounded-full bg-primary/40"></div>
                    <div class="space-y-1">
                        <h2 class="text-lg font-semibold text-base-content">后台任务管理</h2>
                        <p class="text-sm text-base-content/60">后台任务用于执行一些定时任务，例如刮削、删除等。</p>
                    </div>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    <!-- 停止所有后台任务 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-warning/50"></span>
                                    <h3 class="font-medium text-base-content">停止所有后台任务</h3>
                                </div>
                                <p class="text-xs text-base-content/60">用于紧急停止正在执行的后台任务。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.stop_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.stop_task }"
                                        :disabled="loadingTasks.stop_task"
                                        @click="handleTask2('stop_task', formData.backend_task.stop_task)"
                                    >
                                        {{ loadingTasks.stop_task ? '执行中...' : getButtonText(formData.backend_task.stop_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.stop_task }"
                                        :disabled="loadingTasks.stop_task"
                                        @click="handleTask2('stop_task', formData.backend_task.stop_task)"
                                    >
                                        {{ loadingTasks.stop_task ? '执行中...' : getButtonText(formData.backend_task.stop_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.stop_task"
                                        @click="handleTask2('stop_task', formData.backend_task.stop_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.stop_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.stop_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.stop_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.stop_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.stop_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.stop_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.stop_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        
                        
                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.stop_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 刮削艺术家封面 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">刮削艺术家封面</h3>
                                </div>
                                <p class="text-xs text-base-content/60">为艺术家自动获取封面图。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.artist_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.artist_task }"
                                        :disabled="loadingTasks.artist_task"
                                        @click="handleTask2('artist_task', formData.backend_task.artist_task)"
                                    >
                                        {{ loadingTasks.artist_task ? '执行中...' : getButtonText(formData.backend_task.artist_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.artist_task }"
                                        :disabled="loadingTasks.artist_task"
                                        @click="handleTask2('artist_task', formData.backend_task.artist_task)"
                                    >
                                        {{ loadingTasks.artist_task ? '执行中...' : getButtonText(formData.backend_task.artist_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.artist_task"
                                        @click="handleTask2('artist_task', formData.backend_task.artist_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.artist_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.artist_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.artist_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.artist_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.artist_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.artist_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.artist_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.artist_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 合并相似艺术家 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">合并相似艺术家</h3>
                                </div>
                                <p class="text-xs text-base-content/60">生成合并建议，需在审计日志中手动确认。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <button
                                    class="btn btn-xs btn-primary"
                                    :class="{ 'loading': mergingArtists }"
                                    :disabled="mergingArtists"
                                    @click="handleMergeSimilarArtists"
                                >
                                    {{ mergingArtists ? '分析中...' : '立即执行' }}
                                </button>
                                <div class="badge badge-sm badge-ghost">一次性执行</div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100" disabled>
                                <option value="manual" selected>仅支持手动执行</option>
                            </select>
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            执行后请查看审计日志进行手动合并操作
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 删除管理 -->
        <div class="card bg-base-100 border border-base-200 shadow-sm transition-shadow duration-200 hover:shadow-md">
            <div class="card-body space-y-6">
                <div class="flex items-start gap-3">
                    <div class="mt-1 h-5 w-1.5 rounded-full bg-warning/40"></div>
                    <div class="space-y-1">
                        <h2 class="text-lg font-semibold text-base-content">删除管理</h2>
                        <p class="text-sm text-base-content/60">用于清理历史记录与冗余数据，执行前请谨慎确认。</p>
                    </div>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5">
                    <!-- 音乐收藏 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">音乐收藏</h3>
                                </div>
                                <p class="text-xs text-base-content/60">删除数据库中的数据，便于重新导入。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.music_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.music }"
                                        :disabled="loadingTasks.music"
                                        @click="handleTask2('music', formData.backend_task.music_task)"
                                    >
                                        {{ loadingTasks.music ? '执行中...' : getButtonText(formData.backend_task.music_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.music }"
                                        :disabled="loadingTasks.music"
                                        @click="handleTask2('music', formData.backend_task.music_task)"
                                    >
                                        {{ loadingTasks.music ? '执行中...' : getButtonText(formData.backend_task.music_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.music"
                                        @click="handleTask2('music', formData.backend_task.music_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.music_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.music_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.music_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.music_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.music_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.music_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.music_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.music_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 操作记录 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">操作记录</h3>
                                </div>
                                <p class="text-xs text-base-content/60">删除所有操作记录。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.audit_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.audit_log }"
                                        :disabled="loadingTasks.audit_log"
                                        @click="handleTask2('audit_log', formData.backend_task.audit_task)"
                                    >
                                        {{ loadingTasks.audit_log ? '执行中...' : getButtonText(formData.backend_task.audit_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.audit_log }"
                                        :disabled="loadingTasks.audit_log"
                                        @click="handleTask2('audit_log', formData.backend_task.audit_task)"
                                    >
                                        {{ loadingTasks.audit_log ? '执行中...' : getButtonText(formData.backend_task.audit_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.audit_log"
                                        @click="handleTask2('audit_log', formData.backend_task.audit_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.audit_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.audit_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.audit_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.audit_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.audit_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.audit_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.audit_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.audit_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 播放记录 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">播放记录</h3>
                                </div>
                                <p class="text-xs text-base-content/60">清理首页播放记录。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.play_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.play_log }"
                                        :disabled="loadingTasks.play_log"
                                        @click="handleTask2('play_log',formData.backend_task.play_task)"
                                    >
                                        {{ loadingTasks.play_log ? '执行中...' : getButtonText(formData.backend_task.play_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.play_log }"
                                        :disabled="loadingTasks.play_log"
                                        @click="handleTask2('play_log',formData.backend_task.play_task)"
                                    >
                                        {{ loadingTasks.play_log ? '执行中...' : getButtonText(formData.backend_task.play_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.play_log"
                                        @click="handleTask2('play_log',formData.backend_task.play_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.play_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.play_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.play_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.play_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.play_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.play_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.play_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.play_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 刮削记录 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">刮削记录</h3>
                                </div>
                                <p class="text-xs text-base-content/60">清理刮削状态记录。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.tag_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.tag_log }"
                                        :disabled="loadingTasks.tag_log"
                                        @click="handleTask2('tag_log',formData.backend_task.tag_task)"
                                    >
                                        {{ loadingTasks.tag_log ? '执行中...' : getButtonText(formData.backend_task.tag_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.tag_log }"
                                        :disabled="loadingTasks.tag_log"
                                        @click="handleTask2('tag_log',formData.backend_task.tag_task)"
                                    >
                                        {{ loadingTasks.tag_log ? '执行中...' : getButtonText(formData.backend_task.tag_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.tag_log"
                                        @click="handleTask2('tag_log',formData.backend_task.tag_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.tag_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.tag_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.tag_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.tag_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.tag_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.tag_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.tag_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.tag_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 不存在的音乐收藏 -->
                    <div class="rounded-xl border border-base-200 bg-base-200/40 p-5 space-y-4 transition-shadow duration-200 hover:shadow-sm">
                        <div class="flex items-start justify-between gap-3">
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="h-2 w-2 rounded-full bg-primary/50"></span>
                                    <h3 class="font-medium text-base-content">不存在的音乐收藏</h3>
                                </div>
                                <p class="text-xs text-base-content/60">同步清理已删除或不存在的音乐。</p>
                            </div>
                            <div class="flex items-center gap-2">
                                <template v-if="formData.backend_task.track_task.type === 'manual'">
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.track_task }"
                                        :disabled="loadingTasks.track_task"
                                        @click="handleTask2('track_task', formData.backend_task.track_task)"
                                    >
                                        {{ loadingTasks.track_task ? '执行中...' : getButtonText(formData.backend_task.track_task) }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button
                                        class="btn btn-xs btn-primary"
                                        :class="{ 'loading': loadingTasks.track_task }"
                                        :disabled="loadingTasks.track_task"
                                        @click="handleTask2('track_task', formData.backend_task.track_task)"
                                    >
                                        {{ loadingTasks.track_task ? '执行中...' : getButtonText(formData.backend_task.track_task) }}
                                    </button>
                                    <button
                                        class="btn btn-xs btn-outline"
                                        :disabled="loadingTasks.track_task"
                                        @click="handleTask2('track_task', formData.backend_task.track_task, false)"
                                    >
                                        关闭
                                    </button>
                                </template>
                                <div
                                    class="badge badge-sm"
                                    :class="formData.backend_task.track_task.enabled ? 'badge-primary badge-outline' : 'badge-ghost'"
                                >
                                    {{ formData.backend_task.track_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm bg-base-100 focus:select-primary" v-model="formData.backend_task.track_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>

                        <div v-if="formData.backend_task.track_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.track_task.cron" @change="updateSys('backend_task')" />
                        </div>

                        <div v-else-if="formData.backend_task.track_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text text-sm">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm bg-base-100 focus:input-primary" v-model="formData.backend_task.track_task.interval" @change="updateSys('backend_task')" />
                        </div>

                        

                        <div class="text-xs text-base-content/60 flex items-center gap-2 pt-3 border-t border-base-300/70">
                            <svg class="w-3.5 h-3.5 text-base-content/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.track_task.last_run || '未执行' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BackgroundTasks',
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            mergingArtists: false,
            loadingTasks: {}
        }
    },
    created() {
        this.getTaskStatus()
    },
    methods: {
        updateSys(key) {
            this.$emit('update-sys', key)
        },
        getTaskStatus() {
            this.$api.Task.periodicTaskStatus().then((res) => {
                if (res.result) {
                    this.formData.backend_task = res.data
                }
            })
        },
        getButtonText(task) {
            // 手动执行模式:显示"立即执行"
            if (task.type === 'manual') {
                return '立即执行'
            }
            // 定时执行和周期执行模式:根据启用状态显示"下发任务"或"取消任务"
            if (task.type === 'cron' || task.type === 'interval') {
                return task.enabled ? '取消任务' : '下发任务'
            }
            return '立即执行'
        },
        handleTask2(name, item, enabled = true) {
            this.$set(this.loadingTasks, name, true)
            this.$api.Task.createPeriodicTask({name, ...item, enabled}).then((res) => {
                this.$set(this.loadingTasks, name, false)
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.getTaskStatus()
                }
            }).catch((error) => {
                this.$set(this.loadingTasks, name, false)
                this.$myMsg.notify({
                    title: '执行失败',
                    content: '网络错误或服务器异常',
                    type: 'error',
                    time: 3000,
                })
            })
        },
        handleMergeSimilarArtists() {
            this.mergingArtists = true
            this.$api.Task.task2({mode: 'merge_similar_artists'}).then((res) => {
                this.mergingArtists = false
                if (res.result) {
                    const data = res.data
                    if (data.similar_groups_count > 0) {
                        this.$myMsg.notify({
                            title: '分析完成！',
                            content: `找到 ${data.similar_groups_count} 组相似艺术家，共 ${data.detail_count} 条记录。请前往操作日志查看详情并进行合并操作。`,
                            type: 'success',
                            time: 5000,
                        })
                    } else {
                        this.$myMsg.notify({
                            title: '分析完成',
                            content: '未找到相似的艺术家',
                            type: 'info',
                            time: 3000,
                        })
                    }
                } else {
                    this.$myMsg.notify({
                        title: '执行失败',
                        content: res.msg || '执行过程中出现错误',
                        type: 'error',
                        time: 3000,
                    })
                }
            }).catch((error) => {
                this.mergingArtists = false
                this.$myMsg.notify({
                    title: '执行失败',
                    content: '网络错误或服务器异常',
                    type: 'error',
                    time: 3000,
                })
            })
        },
    }
}
</script> 
